module.exports = __webpack_public_path__ + "static/img/scb.42f6a7df.svg";